const Colors = {
  bg: "#224a41",
  h1: "rgb(179, 218, 91)",
  chartreuse: "rgb(179, 218, 91)",
  sub: "rgb(184, 206, 198)",
  sub2: "rgb(49, 100, 91)",
  blue: "#81CEEA",
  lavender: "#B29AF9",
  yellow: "#F3F662",
  orange: "#f8947f",
  fuschia: "#f17592",
  mint: "#70cd96",
  slate: "#46494C",
};

export default Colors;
